import React, { useMemo } from 'react';
import styles from './NumberOfOTPs.styles.scss';
import cn from 'classnames';
import { MAX_NUMBER_OF_OTPS } from './NumberOfOTPs.config';
import { useTranslation } from 'react-i18next';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

const NumberOfOTPs = ({ noOfOTPs, onChange, onGenerate }) => {
  const { t } = useTranslation();

  const validationError = useMemo(() => {
    if (!noOfOTPs || noOfOTPs === '') {
      return null;
    }
    const value = Number(noOfOTPs);
    if (isNaN(value) || value < 1 || value > MAX_NUMBER_OF_OTPS) {
      return t('otp_validation_error');
    }
    return null;
  }, [noOfOTPs, t]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !validationError && noOfOTPs && onGenerate) {
      e.preventDefault();
      onGenerate(noOfOTPs);
    }
  };

  return (
    <div className={cn('', styles.container)}>
      <div className={cn('d-flex gap-2 align-items-center', styles.title)}>
        <p>
          {t('otp_generation_page_number_of_otps', { max: MAX_NUMBER_OF_OTPS })}{' '}
        </p>
        <Tooltip target="#tooltip" />
        <i
          id="tooltip"
          className="pi pi-info-circle"
          data-pr-tooltip={t('tooltips.otps-generate')}
        />
      </div>

      <div className={cn('', styles.inputs)}>
        <InputText
          onChange={onChange}
          onKeyDown={handleKeyDown}
          keyfilter={/([0-9])+/}
          min={1}
          max={MAX_NUMBER_OF_OTPS}
          value={noOfOTPs}
          placeholder={t('enter-the-number-of-otp-codes-from-1-to-100')}
          className={cn(validationError ? 'p-invalid' : '')}
        />
        {validationError && (
          <small className={styles.errorMessage}>{validationError}</small>
        )}
      </div>
    </div>
  );
};

export default React.memo(NumberOfOTPs);
